import { createAction } from "redux-actions";

export const SESSION_REFRESH_TOKEN_SET = "SESSION_REFRESH_TOKEN_SET";

export default createAction<string>(SESSION_REFRESH_TOKEN_SET);
